import { defineComponent as _defineComponent } from 'vue'
import {computed, onMounted, ref, watch, getCurrentInstance} from "vue";
import PrimeDropdown from "@/components/forms/dropdown/themed/PrimeDropdown.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'EpayDocumentTypeOptions',
  props: {
  value: {
    type: String,
    required: false
  },
  disabled: {
    type: Boolean,
    default: false
  },
},
  emits: ['input', 'selected'],
  setup(__props, { emit: emits }) {

const props = __props;



const instance = ref(null)

onMounted(() => {
  instance.value = getCurrentInstance()
})



const isSelectDisabled = computed(() => {
  return props.disabled;
})

const options = computed(() => {
  const $i18n = instance.value?.proxy?.$i18n;
  // console.log('instance 1', instance.value?.proxy?.$i18n.messages, instance.value?.proxy?.$i18n.t('ID Card'))
  return [
    {title: 'ID Card', value: '1'},
    {title: 'Passport', value: '2'},
  ].map((option) => {
    return {
      value: option.value,
      title: $i18n ? $i18n.t(option.title) : option.title,
    }
  })
})

const val = computed({
  get: () => props.value,
  set: (value) => emits('input', value)
})

const selectedOption = computed(() => {
  if (!val.value) return null;
  return options.value.find((option) => option.value === val.value);
})

watch(selectedOption, (v) => {
  emits('selected', v)
})

return { __sfc: true,props, instance, emits, isSelectDisabled, options, val, selectedOption, PrimeDropdown }
}

})